var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHubspot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign",
    clipPath: "url(#clip0_7748_146965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MHE-Post-Launch-Updates"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xCE\x98Marketing/Logos/Sprocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Marketing/Logos/Sprocket",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83854 9.86795C8.86752 9.86795 8.08038 9.08898 8.08038 8.12821C8.08038 7.16728 8.86752 6.38831 9.83854 6.38831C10.8096 6.38831 11.5967 7.16728 11.5967 8.12821C11.5967 9.08898 10.8096 9.86795 9.83854 9.86795ZM10.3649 4.77863V3.23089C10.7731 3.04007 11.0591 2.63139 11.0591 2.1571V2.12137C11.0591 1.46678 10.5179 0.93122 9.85642 0.93122H9.82049C9.15903 0.93122 8.61785 1.46678 8.61785 2.12137V2.1571C8.61785 2.63139 8.90379 3.04023 9.31204 3.23105V4.77863C8.70422 4.87162 8.14887 5.1197 7.69086 5.48481L3.39667 2.17913C3.42501 2.07145 3.44492 1.9606 3.44509 1.84407C3.44576 1.10284 2.83947 0.501003 2.09011 0.500001C1.3411 0.499166 0.732778 1.09933 0.731934 1.84074C0.731091 2.58214 1.33739 3.18397 2.08674 3.18481C2.33085 3.18514 2.5569 3.11653 2.75495 3.00501L6.97896 6.25693C6.6198 6.79349 6.40927 7.43623 6.40927 8.12821C6.40927 8.85259 6.64055 9.5227 7.03125 10.0738L5.74679 11.3451C5.64524 11.3149 5.53997 11.2938 5.42829 11.2938C4.81272 11.2938 4.31354 11.7876 4.31354 12.3968C4.31354 13.0062 4.81272 13.5 5.42829 13.5C6.04404 13.5 6.54304 13.0062 6.54304 12.3968C6.54304 12.2866 6.52179 12.1823 6.49125 12.0818L7.76188 10.8244C8.33866 11.2599 9.05697 11.5217 9.83854 11.5217C11.7325 11.5217 13.2676 10.0023 13.2676 8.12821C13.2676 6.43155 12.0082 5.02988 10.3649 4.77863Z",
    fill: "#F95C35"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7748_146965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    transform: "translate(0.731934 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHubspot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hubspot.bafe5876c62562a8ce5cb5ebb2f98b40.svg";